import React from 'react'
import Badge from 'react-bootstrap/Badge'

interface DescProps {
  description: string
  fontSize?: string // Optional fontSize prop
}

const DescTag: React.FC<DescProps> = ({ description, fontSize }) => {
  return (
    <Badge
      className="description-badge fw-medium"
      style={{ fontSize, color: '#525B75' }} // Dynamically setting the font size
    >
      {description}
    </Badge>
  )
}

export default DescTag
